import React from 'react';
import {useNavigate} from 'react-router-dom';
import {getInputGroupRoute} from '../../../dashboard/category/utilities';

interface IManageFooterProps {
  post: TPost;
  setShow: (e: boolean) => void;
  inputGroupType: number;
  route?: string;
}

function ManageFooter({
  post,
  setShow,
  inputGroupType,
  route,
}: IManageFooterProps) {
  const navigate = useNavigate();
  return (
    <div>
      {post?.status !== 'published' ? (
        <div
          className="d-flex justify-content-end w-100"
          onClick={() => setShow(true)}
        >
          <small className="color-gray-1">حذف آگهی</small>
        </div>
      ) : (
        <div
          className="d-flex justify-content-end w-100"
          onClick={() => {
            navigate(
              route
                ? route
                : '/dashboard/' +
                    getInputGroupRoute[inputGroupType] +
                    '/details/' +
                    post.guid,
              {
                state: {post: post},
              },
            );
          }}
        >
          <small className="color-gray-1">مدیریت آگهی</small>
        </div>
      )}
    </div>
  );
}

export default ManageFooter;
